var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDidxlLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "didxl_logo_svg__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  x: 0,
  y: 0,
  viewBox: "0 0 182.1 84.4",
  style: {
    enableBackground: "new 0 0 182.1 84.4"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".didxl_logo_svg__st0{fill:#fff}.didxl_logo_svg__st1{fill:#f38021}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "didxl_logo_svg__st0",
  d: "M84.1 58.5c-1.9 3.2-5.9 4.9-9.8 4.9-7.7 0-14.1-5.7-14.1-14.6 0-8.9 6.4-14.6 14.1-14.6 4.1 0 8 1.6 9.9 4.8V19.6h5.5v43.2h-5.5v-4.3zm-9.4-18.9c-5 0-9 3.6-9 9.2 0 5.5 4 9.3 9 9.3 4.9 0 9.3-3.4 9.3-9.3 0-6.1-4.8-9.2-9.3-9.2zM33 58.5c-1.9 3.2-5.9 4.9-9.8 4.9C15.5 63.4 9 57.7 9 48.8c0-8.9 6.4-14.6 14.1-14.6 4.1 0 8 1.6 9.9 4.8V19.6h5.5v43.2H33v-4.3zm-9.4-18.9c-5 0-9 3.6-9 9.2 0 5.5 4 9.3 9 9.3 4.9 0 9.3-3.4 9.3-9.3 0-6.1-4.8-9.2-9.3-9.2zM50.2 21c2.1 0 3.8 1.5 3.8 3.5S52.3 28 50.2 28c-2 0-3.8-1.5-3.8-3.5s1.8-3.5 3.8-3.5zm2.7 13.8h-5.4v28h5.4v-28z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "didxl_logo_svg__st1",
  d: "M100.7 28.3c-1.6 4.2-2.5 8.7-2.5 13.5 0 4.3.7 8.5 2 12.3l8.7-13.4-8.2-12.4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "didxl_logo_svg__st1",
  d: "M137 3c-14.1 0-26.3 7.5-33.1 18.7l8.9 13.9 9.1-14h7.6l-12.9 19.2 14.4 22h-7.6l-10.6-16.9-9.5 15.1c6.7 11.7 19.3 19.6 33.7 19.6 21.4 0 38.8-17.4 38.8-38.8S158.4 3 137 3zm22.7 59.8h-22.9V21.5h6.3V57h16.5v5.8z"
})));
export default SvgDidxlLogo;